import { render, staticRenderFns } from "./UnidadeParceiraMunicipioForm.vue?vue&type=template&id=705976bc"
import script from "./UnidadeParceiraMunicipioForm.vue?vue&type=script&lang=js"
export * from "./UnidadeParceiraMunicipioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports